import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Radio, Link as LinkIcon, Plus } from 'lucide-react';

export default function AddSource() {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">Добавить источник</h1>
        <p className="text-slate-400">Выберите тип источника, который вы хотите подключить для аналитики.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link to="/channels" className="group">
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-surface p-8 rounded-2xl border border-white/5 hover:border-primary/50 transition-colors h-full flex flex-col"
          >
            <div className="w-16 h-16 rounded-2xl bg-blue-500/20 text-blue-400 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Radio size={32} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Telegram Канал</h3>
            <p className="text-slate-400 mb-6 flex-1">
              Подключите свой канал через бота-администратора. Анализируйте подписчиков, просмотры и контент.
            </p>
            <div className="flex items-center gap-2 text-primary font-medium">
              Подключить <Plus size={18} />
            </div>
          </motion.div>
        </Link>

        <Link to="/referral-links" className="group">
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-surface p-8 rounded-2xl border border-white/5 hover:border-purple-500/50 transition-colors h-full flex flex-col"
          >
            <div className="w-16 h-16 rounded-2xl bg-purple-500/20 text-purple-400 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <LinkIcon size={32} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Реферальная ссылка</h3>
            <p className="text-slate-400 mb-6 flex-1">
              Создайте уникальную ссылку для отслеживания трафика из внешних источников (Instagram, YouTube, Ads).
            </p>
            <div className="flex items-center gap-2 text-purple-400 font-medium">
              Создать <Plus size={18} />
            </div>
          </motion.div>
        </Link>
      </div>
    </div>
  );
}
